<template>
  <div class="leco-content">
    <div>
      <div class="page-title">Training Feedback Form</div>
      <div v-if="errorMessage != ''" class="alert alert-danger">
        {{ errorMessage }}
      </div>

      <div v-show="mainLoading" class="initial-loader">loading...</div>
      <transition>
        <div v-show="!mainLoading" class="content-inner">
          <div class="row">
            <div class="float-left col-lg-4 training-info">
              <p class="pb-0 mb-0 lh-125">
                <strong class="d-block text-gray-dark border-bottom border-gray">トレーニング名</strong>
                {{ training.training_planning_name }}
              </p>
            </div>
            <div class="float-left col-lg-4 training-info">
              <div class="pb-0 mb-0 lh-125">
                <strong class="d-block text-gray-dark border-bottom border-gray">講師名</strong>
                <div v-for="coach in training.coaches" :key="coach.tpc_id">
                  {{ coach.coach_name }}
                </div>
              </div>
            </div>
            <div class="float-left col-lg-4 training-info">
              <p class="pb-0 mb-0 lh-125">
                <strong class="d-block text-gray-dark border-bottom border-gray">トレーニング日</strong>
                {{ training.datetime_from | moment("YYYY/MM/DD HH:mm") }}～{{
                  training.datetime_to | moment("HH:mm")
                }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="pt-3 float-left col-lg-12">
              <p class="pb-5 mb-0 lh-125">
                <strong class="d-block text-gray-dark border-bottom border-gray">
                  トレーニング資料
                </strong>
                <span v-if="
                  training.training_material_url === null ||
                  training.training_material_url === undefined
                ">
                  （登録なし）
                </span>
                <span v-else-if="
                  training.training_material_url
                    .toLowerCase()
                    .startsWith('https://')
                ">
                  <a :href="training.training_material_url" target="_blank">
                    {{ training.training_material_url }}
                  </a>
                </span>
                <span v-else>
                  {{ training.training_material_url }}
                </span>
              </p>
            </div>
          </div>

          <b-form @submit.prevent="postAnswer">
            <div v-for="question in questions" v-bind:key="question.id">
              <!-- テキストエリアのフォーム生成 -->
              <div class="questionnaire-text">
                {{ question.text }}
                {{ question.required == true ? "【必須】" : "【任意】" }}
              </div>
              <div v-if="question.type == 'textArea'" class="pt-3">
                <b-form-group>
                  <b-form-textarea v-model="answer[question.id]['inputText']" placeholder="Free Text" rows="3"
                    max-rows="10" :required="question.required"></b-form-textarea>
                </b-form-group>
              </div>
              <!-- 横向きラジオボタンのフォーム生成 -->
              <div v-else-if="question.type == 'radioButton'" class="pt-2">
                <b-form-group>
                  <b-form-radio-group v-model="answer[question.id]['inputValue']" :options="question.selections"
                    :name="'q' + question.id" buttons button-variant="outline-secondary" class="select-group"
                    :required="question.required"></b-form-radio-group>
                </b-form-group>
              </div>
              <!-- 横向きチェックボックスのフォーム生成 -->
              <div v-else-if="question.type == 'checkBox'" class="pt-2">
                <div v-for="item in question.selections" v-bind:key="item.id">
                  <input class="form-check-input" v-model="answer[question.id]['inputSelections'][item.id]['value']
                    " type="checkbox" value="" :id="question.id + '-' + [item.id]" />
                  <label class="form-check-label" :for="question.id + '-' + [item.id]">
                    {{ item.text }}
                  </label>
                </div>
              </div>
              <!-- 選択リストのフォーム生成 -->
              <div v-else-if="question.type == 'dropDown'" class="pt-2">
                <b-form-group>
                  <b-form-select v-model="answer[question.id]['inputValue']" :options="question.selections"
                    :required="question.required"></b-form-select>
                </b-form-group>
              </div>
            </div>
            <button type="submit" class="btn btn-outline-secondary float-right anwer-btn">
              回答
            </button>
            <button v-if="isAnswered"
              type="button"
              @click="delete_answer"
              class="btn btn-outline-danger training-delete-btn float-right"
            >
              削除
            </button>
            <loading :active.sync="isPostLoading"></loading>
          </b-form>
        </div>
      </transition>
    </div>

    <!-- 削除前の確認メッセージモーダル -->
    <ConfirmationModal
      :confirmation_title="delConfirm.title"
      :confirmation_top_msg="delConfirm.top_msg"
      :confirmation_warn_list="delConfirm.warn_list"
      v-if="isShowDelConfirmationModal"
      v-on:confirm-cancel="cancelDelConfirmationModal"
      v-on:confirm-ok="okDelConfirmationModal"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import jQuery from "jquery";
import { API_BASE_URL } from "@/common/config";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import cognito from "@/cognito";
import store from "@/store";
import { SET_AUTH } from "@/store/mutations.type";
import ConfirmationModal from "@/components/LECO_ConfirmationModal.vue";

global.jquery = jQuery;
global.$ = jQuery;
window.$ = window.jQuery = require("jquery");

export default {
  name: "questionnaire-answer",
  data() {
    return {
      training: {},
      questions: [],
      answer: {},
      testcheck: [],
      mainLoading: true,
      isPostLoading: false,
      isShowDelConfirmationModal: false,
      delConfirm: {
        title: "アンケート回答を削除しても良いですか？",
        top_msg: "問題がなければ「OK」をクリックしてください。",
        warn_list: []
      },
      errorMessage: "",
      logger: this.$store.state.logger,
      plan_id: 0,
      isAnswered: false
    };
  },
  filters: {
    moment(date, format) {
      return moment(date).format(format);
    }
  },
  components: {
    loading: Loading,
    ConfirmationModal
  },
  async created() {
    // 画面スクロールをトップにする
    this.instantScrollTop();

    this.plan_id = this.$route.params.id;
    this.logger.debug("トレーニング予定を取得。ID=" + this.plan_id);
    let api_url = API_BASE_URL + "training-plannings/" + this.plan_id;
    axios
      .get(api_url, {
        headers: {
          Authorization: this.$store.getters.currentUser.idToken.jwtToken
        }
      })
      .then((result) => {
        this.logger.debug("result:\n" + JSON.stringify(result));
        if ("statusCode" in result.data) {
          //statusCodeが200なら画面表示
          if (result.data.statusCode == 200) {
            this.logger.info("トレーニング予定取得成功");
            this.logger.debug(
              "get result：" + JSON.stringify(result.data.body)
            );
            this.training = result.data.body;
          } else {
            // 200以外はシステム例外画面表示
            this.logger.error(
              "API(get) return statusCode=" +
              result.data.statusCode +
              ", errorMessages=" +
              result.data.errorMessages.message +
              ", uri=" +
              api_url
            );
            this.$router.push("/system-error500");
          }
        } else {
          this.logger.error(
            "API(get) unexpected return response=" +
            JSON.stringify(result) +
            ", uri=" +
            api_url
          );
          this.$router.push("/system-error500");
        }
      })
      .catch((error) => {
        this.logger.error("API(get) error");
        this.logger.error(error);
        this.$router.push("/system-error500");
      });

    this.logger.debug("回答済みアンケート結果を取得。ID=" + this.plan_id);
    let api_url3 =
      API_BASE_URL +
      "training-plannings/" +
      this.plan_id +
      "/questionnaire-answer/";
    axios
      .get(api_url3, {
        headers: {
          Authorization: this.$store.getters.currentUser.idToken.jwtToken
        }
      })
      .then((result) => {
        this.logger.debug("result:\n" + JSON.stringify(result));
        if ("statusCode" in result.data) {
          //statusCodeが200なら画面表示
          if (result.data.statusCode == 200) {
            this.logger.info("回答済みアンケート結果取得成功");
            this.logger.debug(
              "get result：" + JSON.stringify(result.data.body)
            );
            this.logger.debug("isAnswered : " + result.data.body["1"]["id"])
            if (result.data.body["1"]["id"] != null) {
              this.isAnswered = true;
            };

            // 回答結果をセット（未回答の場合は空をセット）
            this.answer = result.data.body;
            this.logger.debug(this.answer);

            // 回答データ取得後に質問情報を取得する。
            // そうしないと、画面描画の不整合が起きるため
            // 質問の枠はあるが、回答データが存在しない
            this.logger.info("質問情報を取得。ID=" + this.plan_id);
            let api_url2 =
              API_BASE_URL +
              "training-plannings/" +
              this.plan_id +
              "/questionnaire-items";
            axios
              .get(api_url2, {
                headers: {
                  Authorization:
                    this.$store.getters.currentUser.idToken.jwtToken
                }
              })
              .then((result) => {
                this.logger.debug("result:\n" + JSON.stringify(result));
                if ("statusCode" in result.data) {
                  //statusCodeが200なら画面表示
                  if (result.data.statusCode == 200) {
                    this.logger.info("質問情報取得成功");
                    this.logger.debug(
                      "get result：" + JSON.stringify(result.data.body)
                    );
                    this.questions = result.data.body.questionnaire;
                    this.logger.debug(this.questions);
                    this.logger.debug(this.answer);

                    // 3つのAPIのレスポンスが全て完了したらローディング終了
                    this.mainLoading = false;
                  } else {
                    // 200以外はシステム例外画面表示
                    this.logger.error(
                      "API(get) return statusCode=" +
                      result.data.statusCode +
                      ", errorMessages=" +
                      result.data.errorMessages.message +
                      ", uri=" +
                      api_url2
                    );
                    this.$router.push("/system-error500");
                  }
                } else {
                  this.logger.error(
                    "API(get) unexpected return response=" +
                    JSON.stringify(result) +
                    ", uri=" +
                    api_url2
                  );
                  this.$router.push("/system-error500");
                }
              })
              .catch((error) => {
                this.logger.error("API(get) error, uri=" + api_url2);
                this.logger.error(error);
                this.$router.push("/system-error500");
              });
          } else {
            // 200以外はシステム例外画面表示
            this.logger.error(
              "API(get) return statusCode=" +
              result.data.statusCode +
              ", errorMessages=" +
              result.data.errorMessages.message +
              ", uri=" +
              api_url3
            );
            this.$router.push("/system-error500");
          }
        } else {
          this.logger.error(
            "API(get) unexpected return response=" +
            JSON.stringify(result) +
            ", uri=" +
            api_url3
          );
          this.$router.push("/system-error500");
        }
      })
      .catch((error) => {
        this.logger.error("API(get) error, uri=" + api_url3);
        this.logger.error(error);
        this.$router.push("/system-error500");
      });
  },
  updated() {
    // 横ラジオボタン「b-form-radio-group」が動的生成されると
    // CSSが適用されないので強制的に後付設定
    global.$(".select-group label").css("width", "100%");
  },
  computed: {
    ...mapGetters(["isAuthenticated", "currentUser"])
  },
  methods: {
    postAnswer: function () {
      this.isPostLoading = true;
      const trainingPlanId = this.$route.params.id;
      this.logger.debug(JSON.stringify(this.answer));
      this.logger.info(
        "アンケート結果を登録：training_plan_id=" + trainingPlanId
      );

      // ポスト前にログインチェック（アクセストークンの最新化）
      this.logger.info("認証状況チェック：requireAuth");
      cognito
        .checkAuthenticated()
        .then((result) => {
          if (result != null) {
            store.commit(SET_AUTH, result);
            this.logger.info("Cognito認証チェックOK");
            this.logger.debug(JSON.stringify(result));
          } else {
            this.logger.error("Cognito認証情報なし。");
            this.logger.error(JSON.stringify(result));
            this.$router.push("/system-error500");
          }
        })
        .catch((err) => {
          this.logger.error("Cognito認証チェックエラー。");
          this.logger.error(JSON.stringify(err));
          this.$router.push("/system-error500");
        });

      let api_url =
        API_BASE_URL +
        "training-plannings/" +
        trainingPlanId +
        "/questionnaire-answer/";

      // アンケートの登録処理
      axios
        .post(api_url, this.answer, {
          headers: {
            Authorization: this.$store.getters.currentUser.idToken.jwtToken
          }
        })
        .then((result) => {
          this.logger.debug("result:\n" + JSON.stringify(result));
          if ("statusCode" in result.data) {
            //statusCodeが200なら予実一覧に遷移（今登録したものを確認できる）
            if (result.data.statusCode == 200) {
              this.logger.debug(JSON.stringify(result));
              this.logger.info("end to post a training questionnaire");
              this.$router.push(
                "/questionnaire-answer-result/" + trainingPlanId
              );
            } else if (result.data.statusCode == 500) {
              this.logger.error(
                "API(post) return statusCode=" +
                result.data.statusCode +
                ", errorMessages=" +
                result.data.errorMessages.message
              );
              this.$router.push("/system-error500");
            } else if (result.data.statusCode == 400) {
              this.errorMessage =
                "入力値に誤りがあります。再度入力してください。解決しない場合は、システム管理者経由でLECOチームにご連絡ください";
              this.isPostLoading = false;
            } else {
              this.logger.error(
                "API(post) return statusCode=" +
                result.data.statusCode +
                ", errorMessages=" +
                result.data.errorMessages.message
              );
              this.$router.push("/system-error500");
            }
          } else {
            this.logger.error(JSON.stringify(result));
            this.logger.error(
              "API(post) return statusCode=" +
              result.data.statusCode +
              ", errorMessages=" +
              result.data.errorMessages.message
            );
            this.$router.push("/system-error500");
          }
        })
        .catch((error) => {
          this.logger.error("API(get) error");
          this.logger.error(JSON.stringify(error));
          this.$router.push("/system-error500");
        });
    },

    delete_answer: function () {
      this.logger.debug("called:delete_answer");

      // 確認ダイアログを表示
      this.openDelConfirmationModal();

    },
    
    openDelConfirmationModal() {
      this.isShowDelConfirmationModal = true;
    },

    cancelDelConfirmationModal: function () {
      this.logger.debug(
        "削除確認モーダルからCancelクリックイベントが返されました"
      );
      this.isShowDelConfirmationModal = false;
    },
    
    okDelConfirmationModal: function () {
      // ローディングアイコン表示
      this.isPostLoading = true;

      let api_url =
        API_BASE_URL +
        "training-plannings/" +
        this.plan_id +
        "/questionnaire-answer";
      axios
        .delete(api_url, {
          headers: {
            Authorization: this.$store.getters.currentUser.idToken.jwtToken
          }
        })
        .then((result) => {
          this.logger.debug(
            "delete questionnaire-answer api result:\n" +
              JSON.stringify(result)
          );
          this.isPostLoading = false;
          if ("statusCode" in result.data) {
            //statusCodeが200なら画面表示
            if (result.data.statusCode == 200) {
              this.logger.info(
                "アンケート回答削除成功。"
              );
              this.$router.push(
                "/questionnaire-answer-result/" + this.$route.params.id);  
            } else {
              this.logger.error(
                "DELETE(questionnaire-answer delete) API Unexpected status error"
              );
              this.logger.error(JSON.stringify(result));
              this.$router.push("/system-error500");
            }
          } else {
            this.logger.error(
              "DELETE(questionnaire-answer delete) API Unexpected error"
            );
            this.logger.error(JSON.stringify(result));
            this.$router.push("/system-error500");
          }
        })
        .catch((error) => {
          this.isPostLoading = false;
          this.logger.error("API(questionnaire-answer delete) error");
          this.logger.error(error);
          this.$router.push("/system-error500");
        });

      this.isShowDelConfirmationModal = false;
    }
  }
};
</script>

<style scoped>
.content-inner {
  padding: 8px;
  margin: 8px;
}

.training-info {
  padding-top: 1rem;
}

.select-group {
  width: 70%;
}

.questionnaire-text {
  margin-top: 30px;
}

@media screen and (max-width: 1240px) {
  .training-info {
    padding-top: 0px;
  }

  .select-group {
    width: 100%;
  }

  .questionnaire-text {
    margin-top: 30px;
  }
}

@media screen and (max-width: 600px) {
  .anwer-btn {
    width: 100% !important;
    margin-top: 10px;
  }

  .select-group label {
    padding: 3px;
  }

  .training-delete-btn {
    width: 100% !important;
    margin-bottom: 20px;
    margin-top: 10px;
  }
}

.anwer-btn {
  width: 150px;
  margin-left: 10px;
}

.training-delete-btn {
  width: 150px;
  margin-left: 10px;
}

/* loadingアイコン用CSS */
.initial-loader {
  font-size: 10px;
  margin: 50px auto;
  text-indent: -9999em;
  width: 5em;
  height: 5em;
  border-radius: 50%;
  background: #000000;
  background: -moz-linear-gradient(left,
      #000000 10%,
      rgba(255, 255, 255, 0) 42%);
  background: -webkit-linear-gradient(left,
      #000000 10%,
      rgba(255, 255, 255, 0) 42%);
  background: -o-linear-gradient(left, #000000 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(left,
      #000000 10%,
      rgba(255, 255, 255, 0) 42%);
  background: linear-gradient(to right,
      #000000 10%,
      rgba(255, 255, 255, 0) 42%);
  position: relative;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}

.initial-loader:before {
  width: 50%;
  height: 50%;
  background: #000000;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}

.initial-loader:after {
  background: #ffffff;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
